import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialExclusiveFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ExclusiveFilterData from "./ExclusiveFilterData";

const ExclusiveFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialExclusiveFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const saveSearchFilterData = {
    property_name: filterData?.property_name,
    noi: filterData?.noi,
    exclusives_over_30_days_no_offer :filterData?.exclusives_over_30_days_no_offer,
    offer_cap_rate: filterData?.offer_cap_rate,
    offer_price: filterData?.offer_price,
    min_asking_cap_rate: filterData?.min_asking_cap_rate,
    min_asking_cap_rate: filterData?.max_asking_cap_rate,
    min_asking_price: filterData?.min_asking_price,
    max_asking_price: filterData?.max_asking_price,
    listing_broker: filterData?.listing_broker ?? "",
    created_start_date: filterData?.created_start_date,
    created_end_date: filterData?.created_end_date,
    status: filterData?.status,
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      property_name: value?.property_name ?? "",
      noi: value?.noi ?? "",
      exclusives_over_30_days_no_offer :value?.exclusives_over_30_days_no_offer,
      offer_cap_rate: value?.offer_cap_rate ?? "",
      offer_price: value?.offer_price ?? "",
      min_asking_cap_rate: value?.min_asking_cap_rate ?? "",
      max_asking_cap_rate: value?.max_asking_cap_rate ?? "",
      min_asking_price: value?.min_asking_price ?? "",
      max_asking_price: value?.max_asking_price ?? "",
      created_start_date: value?.created_start_date ?? "",
      created_end_date: value?.created_end_date ?? "",
      listing_broker: value?.listing_broker ?? "",
      status: value?.status ?? "",
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        from="Exclusive"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialExclusiveFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        desc={`Enter Exclusive Information.`}
        onFilter={handleFilter}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        from={"Exclusive"}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ExclusiveFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default ExclusiveFilter;
